import React from 'react';
import { formatPnlParts } from '../../utils/positionDisplay';
import type { ReconciliationSummary } from '../../types/reconciliation';

interface Props {
  summary: ReconciliationSummary;
}

const ReconciliationSummaryCards: React.FC<Props> = ({ summary }) => {
  const matchedColor =
    summary.total > 0 && summary.matched === summary.total
      ? 'text-green-600 dark:text-green-400'
      : 'text-gray-700 dark:text-gray-300';
  const mismatchedColor =
    summary.mismatched > 0
      ? 'text-red-500 dark:text-red-400'
      : 'text-gray-700 dark:text-gray-300';
  const sideMismatchColor =
    summary.sideMismatched > 0
      ? 'text-red-500 dark:text-red-400'
      : 'text-gray-700 dark:text-gray-300';
  const pnl = formatPnlParts(summary.totalBrokerPnl);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      <Stat label="Instruments" value={String(summary.total)} color="text-gray-900 dark:text-white" />
      <Stat label="Matched" value={String(summary.matched)} color={matchedColor} />
      <Stat label="Mismatched" value={String(summary.mismatched)} color={mismatchedColor} />
      <Stat label="Side Mismatch" value={String(summary.sideMismatched)} color={sideMismatchColor} />
      <Stat label="Broker P&L" value={pnl.text} color={pnl.className} />
    </div>
  );
};

const Stat: React.FC<{ label: string; value: string; color: string }> = ({ label, value, color }) => (
  <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4">
    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">{label}</div>
    <div className={`text-xl font-bold mt-1 tabular-nums ${color}`}>{value}</div>
  </div>
);

export default ReconciliationSummaryCards;
